import { format } from "date-fns";

export const convertDateToJulian = (date) =>{

   const dayCount = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

   let julianDate = 0;

   let julianFormat = undefined;

   if(date instanceof Date){
      
      for (let i = 0; i < date.getMonth(); i++) {
         julianDate += dayCount[i];
      }
      julianDate += date.getDate();
      if (date.getFullYear() % 4 === 0 && date.getMonth() > 1) {
         julianDate++;
      }

      let julianDateFormat = '';

      if(julianDate>99){
         julianDateFormat = julianDate
      }else if(julianDate>9 && julianDate<100){
         julianDateFormat = `0${julianDate}`;
      }else if(julianDate<10){
         julianDateFormat = `00${julianDate}`;
      }
         
      const julianYear = format(date, 'yy');
   
      julianFormat = `${1}${julianYear}${julianDateFormat}`;
   }


   return julianFormat;
}